<template>
  <div class="info-cards-subsection">
    <div class="cards-grid">
      <div class="info-card">
        <div class="card-icon-wrapper">
          <img class="card-icon" alt="Mail" :src="mailIcon" />
        </div>
        <h3 class="card-title">Email</h3>
        <p class="card-description">contact@florisuite.com</p>
        <p class="card-subdescription">Nous répondons sous 24h</p>
      </div>

      <div class="info-card">
        <div class="card-icon-wrapper">
          <img class="card-icon" alt="Phone" :src="phoneIcon" />
        </div>
        <h3 class="card-title">Téléphone</h3>
        <p class="card-description">+33 788029767</p>
        <p class="card-subdescription">Lun-Ven, 9h-18h</p>
      </div>

      <div class="info-card">
        <div class="card-icon-wrapper">
          <img class="card-icon" alt="Map pin" :src="mapPinIcon" />
        </div>
        <h3 class="card-title">Adresse</h3>
        <p class="card-description">254 rue vendome</p>
        <p class="card-subdescription">69003 Lyon, France</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "InfoCardsSubsection",
  data() {
    const publicBase = process.env.BASE_URL || "/";
    return {
      mailIcon: `${publicBase}assets/fonctionnalites/mail.svg`,
      phoneIcon: `${publicBase}assets/fonctionnalites/phone.svg`,
      mapPinIcon: `${publicBase}assets/fonctionnalites/map-pin.svg`,
    };
  },
});
</script>

<style>
.info-cards-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #f1faea;
  display: flex;
  flex-direction: column;
  padding: 80px 30px;
  position: relative;
  width: 100%;
}

.info-cards-subsection .cards-grid {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
}

.info-cards-subsection .info-card {
  align-items: center;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  max-width: 374px;
  min-width: 300px;
  padding: 40px 32px;
  position: relative;
}

.info-cards-subsection .card-icon-wrapper {
  align-items: center;
  background-color: #d2f1ba;
  border-radius: 50%;
  display: flex;
  height: 64px;
  justify-content: center;
  width: 64px;
}

.info-cards-subsection .card-icon {
  display: block;
  height: 32px;
  object-fit: contain;
  width: 32px;
  filter: brightness(0) saturate(100%) invert(16%) sepia(15%) saturate(2100%)
    hue-rotate(118deg) brightness(95%) contrast(95%);
}

.info-cards-subsection .card-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 32px;
  text-align: center;
}

.info-cards-subsection .card-description {
  color: #084734;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
}

.info-cards-subsection .card-subdescription {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
}
</style>
